var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99996 0H28C30.2 0 32 1.79996 32 4.00001V28C32 30.2 30.2 32 28 32H3.99996C1.79996 32 0 30.2 0 28V4.00001C0 1.79996 1.79996 0 3.99996 0V0Z",
    fill: "#5268AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0667 16.7679L21.0667 7.20002C21.0667 6.75994 20.7064 6.40002 20.2667 6.40002H18.6667C18.2269 6.40002 17.8667 6.76014 17.8667 7.20002V17.4682C17.8667 20.1927 15.658 22.4015 12.9334 22.4015C10.2088 22.4015 8.00008 20.1927 8.00008 17.4682V16.5619C8.00008 16.1218 7.64004 15.7619 7.20012 15.7619H5.60008C5.16024 15.7619 4.80012 16.122 4.80012 16.5619L4.80008 17.4682C4.80004 21.9601 8.44149 25.6015 12.9334 25.6015C15.6387 25.6015 18.0351 24.2803 19.5137 22.2483L19.942 21.889L24.8582 26.0142C25.1953 26.2969 25.7024 26.2526 25.9852 25.9155L27.0137 24.6898C27.2966 24.3527 27.2522 23.8457 26.9152 23.5628L22.4311 19.8003L24.9818 17.6601C25.3189 17.3772 25.3632 16.8701 25.0804 16.5331L24.0519 15.3073C23.7691 14.9703 23.262 14.9259 22.9249 15.2087L21.0667 16.7679ZM5.95355 6.40002H7.55362C7.99363 6.40002 8.35354 6.76002 8.35354 7.20002V8.80006C8.35354 9.24006 7.99363 9.60002 7.55362 9.60002H5.95355C5.51355 9.60002 5.15362 9.24006 5.15362 8.80006V7.20002C5.15362 6.76002 5.51355 6.40002 5.95355 6.40002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.581cae1b4c3af5fd7efe2b2726edb95c.svg";
export { ForwardRef as ReactComponent };